import type { DateTime } from "luxon"

export type ModelKey = { providerID: string; modelID: string }
type Visibility = "show" | "hide"

export function resolveProviderSelection(input: { selected: string[]; fallback?: string[]; enabled: boolean }) {
  const selected = [...new Set(input.selected.length > 0 ? input.selected : (input.fallback ?? []))]
  return { enabled: input.enabled && selected.length > 0, selected }
}

function modelKey(model: ModelKey) {
  return `${model.providerID}:${model.modelID}`
}

export function isModelVisible(
  model: ModelKey,
  input: {
    visibility: Map<string, Visibility>
    latest: Set<string>
    release: Map<string, DateTime>
    provider?: {
      enabled: boolean
      selected: Set<string>
    }
  },
) {
  if (model.providerID === "openanalyst") return true
  if (input.provider) {
    if (!input.provider.enabled) return false
    return input.provider.selected.has(model.modelID)
  }
  const key = modelKey(model)
  const state = input.visibility.get(key)
  if (state === "hide") return false
  if (state === "show") return true
  if (input.latest.has(key)) return true
  const date = input.release.get(key)
  if (!date?.isValid) return true
  return false
}
